module.exports = __webpack_public_path__ + "static/cabina-conductor---cupula-2532be9818c741a4695bbbe3daba639b.jpg";